(function(){
    'use strict'

    angular.module('app.core')
    .factory('BloqueoXUsuarioService', BloqueoXUsuarioService);

    BloqueoXUsuarioService.$inject = ['$http', 'apiSettings', 'UserInfoService'];

    function BloqueoXUsuarioService($http, apiSettings, UserInfoService) {

        var api = {
            getBloqueoXCalendarizacion: getBloqueoXCalendarizacion,
            getAll: getAll,
            getAllUsuario: getAllUsuario,
            remove: remove,
            removeAllXUsuario: removeAllXUsuario
        };

        return api;

        function getBloqueoXCalendarizacion(calendarizacionId){

            var url = apiSettings.apiBaseUrl + 'api/bloqueos-usuario/calendarizacion/' + calendarizacionId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/bloqueos-usuario/admin/';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getAllUsuario(){

            var url = apiSettings.apiBaseUrl + 'api/bloqueos-usuario/usuario/';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function remove(bloqueo){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/bloqueos-usuario',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: bloqueo
            });  
            return response;
        };

        function removeAllXUsuario(){

            if(UserInfoService.eliminarBloqueosUsuario)
            {
                var response = $http({  
                    url: apiSettings.apiBaseUrl + 'api/bloqueos-usuario/todos',  
                    method: 'DELETE', 
                    headers: { 
                        'Content-Type': 'application/json' },
                    data: null
                });  
                
                response.then(function(){
                    UserInfoService.eliminarBloqueosUsuario = false;
                });                
            }
        };

    };

})();